// crypto.randomUUID so existe em contexto seguro (https:// ou localhost).
// Servido por http:// num IP da rede local -- que e como o app chega ao celular
// dela, sem hospedagem -- ele e undefined e TODA gravacao lanca TypeError.
//
// crypto.getRandomValues nao tem essa restricao, entao o plano B monta o UUID v4
// a mao. Math.random e o ultimo recurso: os ids sao chave de registro local, nao
// segredo, e um id fraco e melhor que nao conseguir gravar.
function bytesAleatorios(quantidade: number): Uint8Array {
  const bytes = new Uint8Array(quantidade)
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes)
    return bytes
  }
  for (let i = 0; i < quantidade; i++) bytes[i] = Math.floor(Math.random() * 256)
  return bytes
}

export function novoId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  const bytes = bytesAleatorios(16)
  bytes[6] = (bytes[6] & 0x0f) | 0x40 // versao 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80 // variante RFC 4122
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20, 32),
  ].join('-')
}
